import { Injectable } from '@angular/core';
import { CacheService } from '@ngx-cache/core';
import { CacheDuration } from '../../constants/app.constant';

@Injectable()
export class AppCacheService {
  /*********************Constructor*********************/
  constructor(private readonly cache: CacheService) {}
  /*********************Constructor*********************/

  /*********************Service Methods*********************/
  /**
   * Gets the value from cache if the key is provided.
   */
  get(key: string): any {
    if (this.cache.has(key)) {
      return this.cache.get(key);
    } else {
      return undefined;
    }
  }

  /**
   * Sets the value with key in the cache.
   */
  set(key: string, value: any, expiry?: number): boolean {
    expiry = expiry || CacheDuration.Default;
    return this.cache.set(key, value, 0, {
      expiry:
        expiry >= Number.MAX_VALUE
          ? Number.MAX_VALUE
          : Date.now() + expiry * 1000,
      TTL: expiry
    });
  }

  /**
   * Checks if the a key exists in cache
   */
  has(key: string): boolean {
    return this.cache.has(key);
  }

  /**
   * Deletes the value from cache if the key is provided.
   */
  remove(key: string) {
    this.cache.remove(key);
  }

  /**
   * Clears all the key/value from cache.
   */
  clear(): void {
    this.cache.clear();
  }

  /*********************Service Methods*********************/
}
